module.exports = __webpack_public_path__ + "img/840.b02c4840.svg";